// extracted by mini-css-extract-plugin
export default {"headerTitle":"editParser_headerTitle__yCbAt","page":"editParser_page__eTmb9","header":"editParser_header__zh-rd","container":"editParser_container__AjO3C"};